import { createGetOptionsFn } from '@common/selectOptions.services';
import { IReasonOfChangeBase } from './reasonOfChange.models';

export const apiRoutes = {
  reasonOfChangeOptions: '/ReasonOfChanges/Options',
};

export const getReasonOfChangeOptionsAsync = createGetOptionsFn<IReasonOfChangeBase>(apiRoutes.reasonOfChangeOptions);
